import { render } from "./BlogPageMockupShape.vue?vue&type=template&id=4ad83cde&scoped=true"
import script from "./BlogPageMockupShape.vue?vue&type=script&lang=js"
export * from "./BlogPageMockupShape.vue?vue&type=script&lang=js"

import "./BlogPageMockupShape.vue?vue&type=style&index=0&id=4ad83cde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad83cde"]])

export default __exports__